import React, { Component } from 'react';

import { Select } from 'antd'
import t from '../i18n'



const StockLocations = (props) => {

  function handleChange(value) {
    let locations = props.stockLocations
    if (value) {
      locations = props.mode != "single" ? locations.filter((loc) => value.includes(loc.id)) : locations.filter((loc) => value == loc.id)
    }
    props.StockLocationChanged(locations)

  }

  // The below gets the select search working (value)
  // children.push(<Option key={index} value={`${location.name}-${location.id}`} >{location.name}</Option>);

  const children = [];
  props.stockLocations.forEach((location, index) => {
    children.push(<Option key={index} value={location.id}>{location.name}</Option>);

  });

  return (
    <Select
      showSearch
      mode={props.mode || "multiple"}
      style={{ width: '100%' }}
      placeholder={t('stock_locations')}
      onChange={handleChange}
    >
      {children}
    </Select>
  )
}

export default StockLocations